import { Component, OnInit } from "@angular/core";
import { Validators, FormBuilder } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastService } from "ng-uikit-pro-standard";
import { AppConfig } from "src/app/config";
import { DataService } from "src/app/data.service";
import { GUID } from "src/app/guid";

@Component({
  selector: "app-modulesettingnew",
  templateUrl: "./modulesettingnew.component.html",
  styleUrls: ["./modulesettingnew.component.scss"],
})
export class ModulesettingnewComponent implements OnInit {
  guid: GUID;

  isLoading = false;
  isError = false;
  errorMessage = "";
  id = "";
  mode = "new";
  actionForm = this.formBuilder.group({
    type: [""],
    name: ["", Validators.required],
    section: [""],
    root: [""],
    url: [""],
    iconname: [""],
    sequence: [""],
    metaobject: [""],
    active: [true],
    successmessage: [""],
  });

  types = [
    { value: "parent", label: "Parent" },
    { value: "child", label: "Child" },
  ];
  moduleSettingId: string;
  errMessage: any;
  sectionRoot: any;
  allSection: any;
  sections: any[];
  roots: any[];
  selectedSectionId: any;
  metaobjects: any[];
  sectionRootId: any;
  moduleSetting: any;
  isDataLoaded: boolean;
  constructor(
    private formBuilder: FormBuilder,
    private toastrService: ToastService,
    private dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private appConfig: AppConfig
  ) {}

  ngOnInit() {
    this.guid = new GUID();
    this.route.queryParams.subscribe((params) => {
      this.moduleSettingId = this.route.snapshot.params.id;
      this.mode = this.route.snapshot.params.mode;
    });
    console.log(this.mode);
    // this.getSectionRoot();
    this.getActiveObjectsByType();
    if (this.mode.toLocaleLowerCase() == "edit") {
      // this.actionForm.controls.type.disable();
      this.getSectionRoot().then(() => {
        this.getModuleSettingById();
      });
      // this.getSectionRoot().then((res) => {
      //   this.getModuleSettingById();
      // });
    }
    if (this.mode.toLocaleLowerCase() == "new") {
      this.getSectionRoot();
      this.actionForm.controls.type.enable();
    }
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Metaobject Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  cancel() {
    this.router.navigateByUrl("home/modulesettinglist");
  }

  getSectionRootById() {
    return new Promise((resolve, reject) => {
      console.log("getcrudmessages");

      // alert(id)
      const id = this.sectionRootId;
      const organizationid = localStorage.getItem("crm_orgid");

      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );
      this.isLoading = true;
      this.dataService
        .getSectionRootById(domain, subdomain, organizationid, id)
        .subscribe(
          (res) => {
            console.log("res", res);

            if (res.success == 1) {
              this.sectionRoot = res.data.sectionroot[0];
              console.log("Doneeee****", this.sectionRoot);

              if (this.sectionRoot != null) {
                this.actionForm.controls["name"].setValue(
                  this.sectionRoot.name
                );
                this.actionForm.controls["type"].setValue(
                  this.sectionRoot.type
                );
              }

              this.isLoading = false;
            } else {
              console.log("Error while saving");
              this.isLoading = false;
            }
          },
          (err) => {
            console.log("Error***:", err);
            this.errorMessage = err.message;
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        );
    });
  }

  sectionChange(event: any) {
    console.log(event);
    this.selectedSectionId = event.value;
    var rootArr = [];
    //just add an empty entry sice this field is optional
    // secArr.push({ value: "", label: "--None--" });
    if (this.selectedSectionId) {
      for (let i = 0; i < this.allSection.length; i++) {
        console.log(this.allSection[i].type);
        console.log(this.allSection[i].sectionid);
        console.log(this.selectedSectionId);

        if (
          this.allSection[i].type.toLocaleLowerCase() == "root" &&
          this.allSection[i].sectionid === this.selectedSectionId
        ) {
          console.log("*********");
          rootArr.push({
            value: this.allSection[i].id,
            label: this.allSection[i].name,
          });
        }
      }
    }
    this.roots = rootArr;
  }

  getSectionRoot() {
    return new Promise((resolve, reject) => {
      console.log("getSectionRoot");

      // alert(id)
      const organizationid = localStorage.getItem("crm_orgid");
      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );
      this.isLoading = true;
      this.dataService
        .getAllSectionRoot(domain, subdomain, organizationid)
        .subscribe(
          (res) => {
            console.log("res", res);

            if (res.success == 1) {
              this.allSection = res.data.sectionroot;
              console.log("Doneeee****", this.allSection);

              var secArr = [];
              //just add an empty entry sice this field is optional
              // secArr.push({ value: "", label: "--None--" });
              for (let i = 0; i < this.allSection.length; i++) {
                if (this.allSection[i].type.toLocaleLowerCase() == "section") {
                  secArr.push({
                    value: this.allSection[i].id,
                    label: this.allSection[i].name,
                  });
                }
              }
              this.sections = secArr;

              // this.sectionChange

              if (this.mode.toLocaleLowerCase() == "edit") {
                var rootArr = [];
                //just add an empty entry sice this field is optional
                // secArr.push({ value: "", label: "--None--" });
                if (this.selectedSectionId) {
                  for (let i = 0; i < this.allSection.length; i++) {
                    console.log(this.allSection[i].type);
                    console.log(this.allSection[i].sectionid);
                    console.log(this.selectedSectionId);

                    if (
                      this.allSection[i].type.toLocaleLowerCase() == "root" &&
                      this.allSection[i].sectionid === this.selectedSectionId
                    ) {
                      console.log("*********");
                      rootArr.push({
                        value: this.allSection[i].id,
                        label: this.allSection[i].name,
                      });
                    }
                  }
                }
                this.roots = rootArr;
              }
              if (this.mode.toLocaleLowerCase() == "new") {
                this.isDataLoaded = true;
                this.isLoading = false;
              }
              resolve(null);
            } else {
              console.log("Error while retrieving");
              this.isLoading = false;
              resolve(null);
            }
          },
          (err) => {
            console.log("Error***:", err);
            this.errorMessage = err.message;
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        );
    });
  }

  getActiveObjectsByType() {
    return new Promise((resolve, reject) => {
      console.log("getActiveObjectsByType");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          metaobject: {
            objecttype: "Domain",
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getActiveObjectsByType(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            var activeObjects = res.data.metaobjects;
            var objArr = [];
            //just add an empty entry sice this field is optional
            // objArr.push({ value: "", label: "--None--" });
            for (let i = 0; i < activeObjects.length; i++) {
              objArr.push({
                value: activeObjects[i].name,
                label: activeObjects[i].name,
              });
            }
            this.metaobjects = objArr;

            // this.isLoading = false;

            resolve(null);
          } else {
            console.log("No metaobject data!");
            this.errorMessage =
              res != null ? res.message : "No metaobject data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getModuleSettingById() {
    return new Promise((resolve, reject) => {
      console.log("getModuleSettingById");

      // alert(id)
      const id = this.moduleSettingId;
      const organizationid = localStorage.getItem("crm_orgid");

      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );
      this.isLoading = true;
      this.dataService
        .getModuleSettingById(domain, subdomain, organizationid, id)
        .subscribe(
          (res) => {
            console.log("res", res);

            if (res.success == 1) {
              this.moduleSetting = res.data.menusetting[0];
              console.log("Doneeee****", this.moduleSetting);

              if (this.moduleSetting != null) {
                this.actionForm.controls["name"].setValue(
                  this.moduleSetting.name
                );
                this.actionForm.controls["url"].setValue(
                  this.moduleSetting.url
                );
                this.actionForm.controls["iconname"].setValue(
                  this.moduleSetting.iconname
                );
                this.actionForm.controls["sequence"].setValue(
                  this.moduleSetting.sequence
                );
                this.actionForm.controls["metaobject"].setValue(
                  this.moduleSetting.metaobject
                );
                this.actionForm.controls["section"].setValue(
                  this.moduleSetting.sectionid
                );
                this.actionForm.controls["root"].setValue(
                  this.moduleSetting.rootid
                );
                this.actionForm.controls["metaobject"].setValue(
                  this.moduleSetting.metaobjectname
                );
                this.actionForm.controls["active"].setValue(
                  this.moduleSetting.active
                );

                var rootArr = [];
                //just add an empty entry sice this field is optional
                // secArr.push({ value: "", label: "--None--" });
                // if (this.selectedSectionId) {
                for (let i = 0; i < this.allSection.length; i++) {
                  if (
                    this.allSection[i].type.toLocaleLowerCase() == "root" &&
                    this.allSection[i].sectionid ===
                      this.moduleSetting.sectionid
                  ) {
                    rootArr.push({
                      value: this.allSection[i].id,
                      label: this.allSection[i].name,
                    });
                  }
                  // }
                }
                this.roots = rootArr;
              }
              this.isDataLoaded = true;

              this.isLoading = false;
            } else {
              console.log("Error while saving");
              this.isLoading = false;
            }
          },
          (err) => {
            console.log("Error***:", err);
            this.errorMessage = err.message;
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        );
    });
  }

  save() {
    if (this.actionForm.controls["name"].value.toString().trim() == "") {
      this.showWarning("Name is mandatory");
      return;
    }
    if (this.actionForm.controls["url"].value.toString().trim() == "") {
      this.showWarning("Url is mandatory");
      return;
    }

    console.log("seq", this.actionForm.controls["sequence"].value);
    if (this.actionForm.controls["sequence"].value == "") {
      this.showWarning("Sequence is mandatory");
      return;
    }

    console.log("mode", this.mode);
    if (this.mode.toLowerCase() == "new") {
      this.moduleSettingId = this.guid.getGUID("modulesettings");
    }

    //prepare data for saving: application
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      // profileid: userDetail.profileid,
      // profilename: userDetail.profilename,
      data: {
        modulesetting: {
          id: this.moduleSettingId,
          metaapplicationid: localStorage.getItem("crm_metaapplicationid"),

          mode: this.mode,
          name: this.actionForm.controls["name"].value.trim(),
          url: this.actionForm.controls["url"].value.trim(),
          iconname: this.actionForm.controls["iconname"].value.trim(),
          sequence: this.actionForm.controls["sequence"].value,
          sectionid: this.actionForm.controls["section"].value.trim(),
          rootid: this.actionForm.controls["root"].value.trim(),
          metaobjectname: this.actionForm.controls["metaobject"].value.trim(),
          menutype: "Application",
          visibility: "Default On",
          type: "parent",
          active: this.actionForm.controls["active"].value,
        },
      },
    };

    console.log(postOption);
    this.isLoading = true;
    this.dataService.upsertModuleSetting(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl("home/modulesettinglist");
        } else {
          console.log("error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
